import _ from 'lodash';

import { getConditionalArray } from 'utils/data';

import { FormFillState } from '../../StepDetailPane/FormReviewCard/FormReviewCard.constants';

const SUBTITLE_SEPARATOR = ' · ';

const getBorrowerFullName = borrower => {
  const { firstName, lastName } = borrower ?? {};

  return [firstName, lastName].filter(part => !_.isNil(part) && part !== '').join(' ');
};

export const buildExecutionSubtitle = ({ loanNumber, primaryBorrower }) => {
  const borrowerName = getBorrowerFullName(primaryBorrower);
  const hasLoanNumber = !_.isNil(loanNumber) && loanNumber !== '';
  const hasBorrowerName = borrowerName !== '';

  const parts = [
    ...getConditionalArray(hasLoanNumber, () => [`Loan #${loanNumber}`]),
    ...getConditionalArray(hasBorrowerName, () => [borrowerName]),
  ];

  return parts.length > 0 ? parts.join(SUBTITLE_SEPARATOR) : null;
};

// A paused run has no completedAt, so "not complete" alone would claim the AI is
// still filling while it is actually waiting on a person.
export const resolveFormFillState = ({ isRunComplete, isNeedsInput, runningCount }) => {
  if (isRunComplete) {
    return FormFillState.DONE;
  }

  if (isNeedsInput && runningCount === 0) {
    return FormFillState.PAUSED;
  }

  return FormFillState.FILLING;
};
